<template>
  <div class="home">
    <panelify
      extName="camAssist"
      appName="AEFT"
      src="https://camera-manager-panel.web.app/#/"
      width="500px"
      height="300px"
      :gradient="0"
      style="padding: 20px; max-width: 90vw;"
    />
    <panelify
      extName="camAssist"
      appName="AEFT"
      src="https://camera-manager-panel.web.app/#/"
      width="500px"
      height="200px"
      :gradient="50"
      style="padding: 20px; max-width: 90vw;"
    />
    <panelify
      extName="camAssist"
      appName="AEFT"
      src="https://camera-manager-panel.web.app/#/"
      width="249px"
      height="400px"
      :gradient="100"
      style="padding: 20px; max-width: 90vw;"
    />
    <panelify
      extName="Illustrator Style"
      appName="ILST"
      theme="darkest"
      width="600px"
      height="200px"
      style="padding: 20px; max-width: 90vw;"
    />
  </div>
</template>

<script>
import { panelify } from "@inventsable/panelify";

export default {
  name: "home",
  components: {
    panelify
  }
};
</script>

<style>
.home {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
}
</style>
